<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T1x4zL/images/cover.jpg?1690496876516" alt="This image is the cover for the book Dictionary of Foreign Words and Phrases"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dictionary of Foreign Words and Phrases
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A fascinating A-to-Z reference to foreign words and phrases that have become part of contemporary English usage.</b></p><p> The English language has been greatly enriched by a vast array of words and phrases imported from other tongues, such as <i>comrade</i>, <i>chateau</i>, <i>wunderkind</i>, and <i>vox populi</i>. For the average English speaker, many are bound to be familiar. Some may even appear to be standard English, while others may seem, well,<i></i>foreign. <i>A Dictionary of Foreign Words and Phrases</i> presents a comprehensive list of such terms, with entries that reveal their meanings and etymologies. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A J Bliss
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Philosophical Library/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1257c56